import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
//import { loadLanguages } from 'i18next';
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

//IMG IMPORT
import aboutus from "./images/about_us.jpg";
import user_support from "./images/user_support.jpg";
import nodejsreactjs from "./images/nodejsreactjs.jpg";

//HELMET
import { Helmet } from "react-helmet-async";

function App() {
  const { t } = useTranslation();


  const [ime, setIme] = useState("");
  const [email, setEmail] = useState("");
  const [body, setBody] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // POST podaci ka serveru
    axios.post(
      `/api/home/message`,
      { ime, email, body }   // šaljemo sva tri polja
      )
      .then(res => {
        setMsg(res.data.message);
        setIme("");
        setEmail("");
        setBody("");
      })
      .catch(err => {
        console.error(err);
        setMsg("Greška pri slanju poruke ❌");
      });
  };



  return (

    <>
      <Helmet>
        <title>Web Dizajn i Izrada Sajtova u Srbiji | AlphaPremiumSolutions</title>

        <meta
          name="description"
          content="Profesionalna izrada sajtova u Srbiji, web dizajn i razvoj modernih web aplikacija. Pomažemo firmama u Srbiji da unaprede online prisustvo i povećaju prodaju."
        />

        <meta
          name="keywords"
          content="web dizajn, izrada sajtova, web development, SEO optimizacija, izrada web shopa, Srbija, izrada sajtova Srbija, sajtovi Srbija"
        />

        <meta name="author" content="AlphaPremiumSolutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Web Dizajn i Izrada Sajtova | AlphaPremiumSolutions"
        />
        <meta
          property="og:description"
          content="Moderni, brzi i SEO optimizovani web sajtovi za firme u Srbiji."
        />
        <meta property="og:url" content="https://alphapremiumsolutions.com/" />
        <meta property="og:locale" content="sr_RS" />
        <meta property="og:image" content="https://alphapremiumsolutions.com/og-image.jpg" />
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Web Dizajn i Razvoj | AlphaPremiumSolutions"
        />
        <meta
          name="twitter:description"
          content="Profesionalna izrada modernih i skalabilnih web sajtova."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://alphapremiumsolutions.com/" />

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": ["LocalBusiness", "ProfessionalService"],
              "@id": "https://alphapremiumsolutions.com/",
              "name": "AlphaPremiumSolutions",
              "url": "https://alphapremiumsolutions.com",
              "logo": "https://alphapremiumsolutions.com/logo.png",
              "image": "https://alphapremiumsolutions.com/og-image.jpg",
              "description": "Profesionalna izrada sajtova, web dizajn i razvoj web aplikacija u Srbiji.",
              "email": "info@alphapremiumsolutions.com",
              "telephone": "+381638597131",
              "priceRange": "€€",
              "areaServed": {
                "@type": "Country",
                "name": "Serbia"
              },
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Beograd",
                "addressRegion": "RS",
                "addressCountry": "RS"
              },
              "sameAs": [
                "https://www.linkedin.com/company/alphapremiumsolutions",
                "https://www.instagram.com/alphapremiumsolutions",
                "https://www.facebook.com/alphapremiumsolutions"
              ],
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Web Usluge",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Izrada Web Sajtova"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "SEO Optimizacija"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Razvoj Web Aplikacija"
                    }
                  }
                ]
              }
            }
            `}
        </script>
      </Helmet>

      <div className="App">
        <header className="App-header">
          <div>

            {/* Hero */}
            <header
              id="home"
              className="bg-dark text-white py-5"
              style={{
                background:
                  "linear-gradient(120deg, rgba(13,110,253,0.2), rgba(0,0,0,0.9))",
              }}
            >
              <div className="container py-5">
                <div className="row align-items-center g-5">
                  <div className="col-lg-6">
                    <h2 className="display-5 fw-bold">
                      {t("body.t1")}{" "}
                      <span className="text-primary">{t("body.t2")}</span>.
                    </h2>
                    <p className="lead text-white-50 mt-3">
                      {t("body.t3")}
                    </p>

                    <div className="d-flex gap-3 mt-4">
                      <Link to="/login" className="btn btn-primary btn-lg">
                        {t("body.t4")}
                      </Link>
                      <Link to="/services" className="btn btn-outline-light btn-lg">
                        {t("body.t5")}
                      </Link>
                    </div>

                    <div className="d-flex gap-4 mt-4 text-white-50">
                      <div>
                        <div className="fw-bold text-white">50+</div>
                        <small>{t("body.t6")}</small>
                      </div>
                      <div>
                        <div className="fw-bold text-white">5★</div>
                        <small>{t("body.t7")}</small>
                      </div>
                      <div>
                        <div className="fw-bold text-white">24/7</div>
                        <small>{t("body.t8")}</small>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="card bg-black border-0 shadow-lg rounded-4">
                      <div className="card-body p-4">
                        <h5 className="fw-bold text-white mb-3">
                          {t("body.t9")}
                        </h5>
                        {/*FORMA ZA PODATKE*/}
                        <form onSubmit={handleSubmit}>
                          <div className="mb-3">
                            <label className="form-label text-white-50">{t("body.t10")}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="name"
                              value={ime}
                              onChange={(e) => setIme(e.target.value)}
                              required
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label text-white-50">{t("body.t11")}</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="example@email.com"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>

                          <div className="mb-3">
                            <label className="form-label text-white-50">{t("body.t12")}</label>
                            <textarea
                              className="form-control"
                              placeholder="Your message..."
                              value={body}
                              onChange={(e) => setBody(e.target.value)}
                              rows={4}
                              required
                            />
                          </div>

                          <button type="submit" className="btn btn-primary w-100">
                            {t("body.t13")}
                          </button>

                          {msg && <small className="text-white-50 d-block mt-2">{msg}</small>}
                        </form>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <div className="carousel-wrapper">
              {/* CAROUSEL */}
              <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">

                <div className="carousel-indicators">
                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"></button>
                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></button>
                  <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></button>
                </div>

                <div className="carousel-inner">

                  <div className="carousel-item active">
                    <img className="d-block w-100" loading="lazy" src={aboutus} alt="Izrada web sajtova i web aplikacija u Srbiji" />
                    <div className="carousel-caption d-none d-md-block">
                      <Link to="/about"><h3 className="text-black">{t("about.t1")}</h3></Link>
                      <p className="text-black">{t("about.t2")}</p>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img className="d-block w-100" loading="eager" src={nodejsreactjs} alt="Izrada sajtova koriscenjem novijih tehnologija" />
                    <div className="carousel-caption d-none d-md-block">
                      <h3 className="text">{t("services.p1")}</h3>
                      <p className="text">{t("services.c4")}</p>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img className="d-block w-100" loading="eager" src={user_support} alt="24/7 korisnicka podrska" />
                    <div className="carousel-caption d-none d-md-block">
                      <Link to="/contact"><h3 className="text-black">{t("services.t9")}</h3></Link>
                      <p className="text-black">{t("services.t10")}</p>
                    </div>
                  </div>

                </div>

                {/* Previous */}
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon"></span>
                </button>

                {/* Next */}
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                  <span className="carousel-control-next-icon"></span>
                </button>

              </div>
            </div>
            <div className="container py-5">

              <div className="jumbotron">
                <h1 className="display-4">Alpha Premium Solutions</h1>
                <p className="lead">{t("jumbotron1.t1")}</p>
                <hr className="my-4"></hr>
                <p>{t("jumbotron1.t2")}</p>
                <p className="lead">
                  <a className="btn btn-primary btn-lg" href="/services" role="button">{t("jumbotron1.t3")}</a>
                </p>
              </div>

              {/* Zašto izabrati nas */}
              <section className="py-5 mt-5 bg-light">
                <div className="container">
                  <div className="text-center mb-5">
                    <h2 className="fw-bold display-6 text-black">{t("clients_chose.t1")}</h2>
                  </div>

                  <div className="row g-4 justify-content-center">
                    {[
                      { icon: "bi-laptop", title: t("clients_chose.t2") },
                      { icon: "bi-speedometer2", title: t("clients_chose.t3") },
                      { icon: "bi-code-slash", title: t("clients_chose.t4") },
                      { icon: "bi-calendar-check", title: t("clients_chose.t5") },
                      { icon: "bi-gear", title: t("clients_chose.t6") },
                    ].map((item, i) => (
                      <div className="col-md-6 col-lg-4" key={i}>
                        <div className="card h-100 border-0 shadow-sm rounded-4 p-4 text-center transition-hover">
                          <div className="icon-wrapper mb-3">
                            <i className={`bi ${item.icon} fs-1 text-primary`}></i>
                          </div>
                          <h5 className="fw-semibold">{item.title}</h5>
                          <p className="text-muted small mt-2">
                            {t(`clients_chose.desc${i + 2}`) || "Detaljniji opis prednosti."}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>

              {/* Opcionalno: mini testimonials */}
              <section className="py-5 mt-5">
                <div className="text-center mb-5">
                  <h2 className="fw-bold">{t("clients_say.t1")}</h2>
                  <p className="text">{t("clients_say.t2")}</p>
                </div>
                <div className="row g-4">
                  {[t("clients_say.t3"), t("clients_say.t5"), t("clients_say.t7")].map((text, i) => (
                    <div className="col-md-4" key={i}>
                      <div className="card h-100 shadow-sm rounded-4 p-4">
                        <p className="text">“{text}”</p>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

            </div>




          </div>
        </header>
      </div>
    </>
  );
}

export default App;
